import { memo } from 'react';
import Button from '@cloudscape-design/components/button';
import Popover from '@cloudscape-design/components/popover';
import HomeFilter, { SearchHomeRequest } from './HomeFilter';

interface FilterButtonProps {
  searchParams: SearchHomeRequest;
  type: 'task' | 'audit';
  onSearchChange: (searchParams: SearchHomeRequest) => void;
}

const FilterButton = memo(({ onSearchChange, searchParams, type }: FilterButtonProps) => {
  const activeFilters = Object.values(searchParams).filter((value) => value).length;
  return (
    <Popover
      data-testid="filter-popover"
      dismissButton={true}
      position="bottom"
      size="large"
      triggerType="custom"
      fixedWidth={true}
      content={
        <HomeFilter
          type={type}
          onSearchChange={onSearchChange}
          defaultSearchParams={searchParams}
        />
      }
    >
      <Button iconName="filter" data-testid="filter-button">
        {' '}
        Filter
        {activeFilters > 0 && ` (${activeFilters})`}
      </Button>
    </Popover>
  );
});

export default FilterButton;
